module.exports = __webpack_public_path__ + "static/media/search.2d36c008.svg";